// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActivityMultiEmployersSummaryRecordDto } from './IClaimActivityMultiEmployersSummaryRecordDto';
import {
    IClaimActivityMultiEmployersSummaryRecordDtoFromJSON,
    IClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped,
    IClaimActivityMultiEmployersSummaryRecordDtoToJSON,
    IClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IClaimActivityMultiEmployersSummaryRecordDto';
import type { IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto } from './IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto';
import {
    IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IClaimActivityMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto
     */
    employer_records?: Array<IClaimActivityMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IClaimActivityMultiEmployersSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoClaimActivityMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IClaimActivityMultiEmployersSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoClaimActivityMultiEmployersSummaryRecordDtoToJSON)),
    };
}

